module.exports = __webpack_public_path__ + "img/6.e4f1b016.jpg";